import { Injectable, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BRAND } from './brand';
import { seoDataForRoute } from './routing/route-catalog';

const DEFAULT_TYPE = 'website';
const TWITTER_CARD = 'summary_large_image';

@Injectable({ providedIn: 'root' })
export class SeoService {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly router = inject(Router);

  start(): void {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event) => this.updateMetadata(event.urlAfterRedirects));
  }

  private updateMetadata(url: string): void {
    const data = seoDataForRoute(url);

    const title = data.title ?? BRAND.name;
    const description = data.description ?? BRAND.description;
    const image = data.image ?? BRAND.assets.openGraphDefault;
    const type = data.type ?? DEFAULT_TYPE;
    const origin =
      typeof window !== 'undefined' ? window.location.origin : '';
    const canonicalUrl = `${origin}${url}`;

    this.title.setTitle(title);

    this.meta.updateTag({ name: 'description', content: description });

    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: type });
    this.meta.updateTag({ property: 'og:url', content: canonicalUrl });
    this.meta.updateTag({ property: 'og:image', content: image });

    this.meta.updateTag({ name: 'twitter:card', content: TWITTER_CARD });
    this.meta.updateTag({ name: 'twitter:title', content: title });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: image });
  }
}
